export const API_BASE_URL = 'https://api.arithmeticblitz.com';

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
